import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { DashboardYearFilter } from '../components/DashboardYearFilter';
import { useGPAData } from '../contexts';

export const GPAFilterControls = () => {
    const { filter, updateFilter, activeSchoolYear, termTypes } = useGPAData();
    const termTypeId = filter.termTypeId || 0;
    const selectedTermType = termTypes.find(termType => termType.id === termTypeId);
    const termCount = selectedTermType?.termCount || 1;
    return <DashboardYearFilter idPrefix="gpa" years={filter.schoolYears} activeSchoolYear={activeSchoolYear}
        onApply={schoolYears => updateFilter({ schoolYears })}>
        <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Term Type</InputLabel>
            <Select value={termTypeId} label="Term Type" onChange={event => {
                const value = Number(event.target.value);
                updateFilter(value ? { termTypeId: value, termNumber: 1 } : { termTypeId: undefined, termNumber: undefined });
            }}>
                <MenuItem value={0}>Whole Year</MenuItem>
                {termTypes.map(termType =>
                    <MenuItem key={termType.id} value={termType.id}>{termType.name}</MenuItem>)}
            </Select>
        </FormControl>
        {termTypeId > 0 && <FormControl size="small" sx={{ minWidth: 110 }}>
            <InputLabel>Term</InputLabel>
            <Select value={filter.termNumber || 1} label="Term" onChange={event => updateFilter({ termNumber: Number(event.target.value) })}>
                {Array.from({ length: termCount }, (_, index) => index + 1)
                    .map(number => <MenuItem key={number} value={number}>{number}</MenuItem>)}
            </Select>
        </FormControl>}
    </DashboardYearFilter>;
};
